import {
  COLOMBIAHOSTING_HOMEPAGE,
  GODADDY_HOMEPAGE, LOCAWEB_HOMEPAGE, NEUBOX_HOMEPAGE, REGISTROBR_HOMEPAGE, SUPPORT_ARTICLE_CHANGE_DNS_COLOMBIAHOSTING, SUPPORT_ARTICLE_CHANGE_DNS_GODADDY, SUPPORT_ARTICLE_CHANGE_DNS_LOCAWEB, SUPPORT_ARTICLE_CHANGE_DNS_NEUBOX, SUPPORT_ARTICLE_CHANGE_DNS_OTHERS, SUPPORT_ARTICLE_CHANGE_DNS_REGISTROBR, SUPPORT_ARTICLE_CHANGE_DNS_UOLHOST, SUPPORT_ARTICLE_CHANGE_DNS_WEBEMPRESA, UOLHOST_HOMEPAGE,
  WEBEMPRESA_HOMEPAGE,
} from '@/config/urls/supportUrls';
import { PROVIDERS } from '@/pages/Domains/ChangeDomainHandler/components/ExternalDomain/ExternalDomain.types';
import { Link } from 'gatorcomponents';
import React from 'react';

export default {
  steps: {
    inputDomain: {
      title: 'Qual é o endereço do seu site?',
      description: 'Defina o novo domínio do seu site',
      continueCta: 'Continuar',
      backCta: 'Voltar',
      alertDescription: domain => (
        <>
          {'O novo domínio substituirá o atual '}
          <Link text={domain} href={`http://${domain}`} target="_blank" />
        </>
      ),
      toggledContent: 'O site ficará indisponível até que todo o processo seja concluído.',
      toggleCta: 'Como funciona',
      temporaryToggledContent: (
        <>
          <span>No momento, o endereço do seu site é temporário</span>

          <span>
            {'O domínio temporário serve como um endereço provisório para hospedar e acessar o seu site em '}
            <strong>fase de testes ou desenvolvimento</strong>
            {', antes de vinculá-lo a um '}
            <strong>domínio próprio.</strong>
          </span>

          <span>O site ficará indisponível até que todo o processo seja concluído.</span>
        </>
      ),
      mySiteLabel: 'meusite.com',
      domainEqualOriginalDomain: 'O domínio informado é o mesmo já utilizado nesse site. Preencha outro domínio para seguir com a alteração.',
      domainMessageErrorBr: 'Domínio inválido! Não pode conter caracteres especiais (exceto hífen), iniciar e finalizar com hífen, conter apenas números ou ter mais de 26 caracteres.',
      domainMessageError: 'Domínio inválido! Não pode conter caracteres especiais (exceto hífen), iniciar e finalizar com hífen, conter apenas números ou ter mais de 63 caracteres.',
      backendErrors: {
        genericError: {
          title: 'Não foi possível prosseguir com o domínio informado',
          info: 'Por favor, preencha o campo seguindo os padrões de um domínio (exemplo: meusite.com.br) ou preencha o campo com outro domínio.',
        },
        HOSTING_NOT_AVAILABLE: {
          title: 'Não encontramos uma hospedagem ou servidor para o seu domínio',
          info: 'Verifique as informações e tente novamente',
        },
        NOT_UPDATE_DOMAIN_IN_CPANEL_HOSTING: {
          title: 'Este domínio já está vinculado à sua hospedagem.',
          info: '',
        },
        SAME_DOMAIN: {
          title: 'Domínio já cadastrado',
          info: 'O domínio que você está tentando cadastrar já está vinculado à sua conta.',
        },
      },
    },
    domainNotRegistered: {
      title: 'O domínio indicado está disponível para compra',
      description: 'Você será redirecionado para compra-lo e poderá retornar para concluir a configuração',
      backButton: 'Voltar',
      continueButton: 'Comprar domínio',
    },
    success: {
      title: 'Pronto! Seu domínio está sendo configurado com sucesso',
      description: 'Aguarde até 2 horas para o site entrar no ar com o novo domínio',
      helpLabel: (
        <>
          {'Em caso de dúvidas, '}
          <Link
            text="acesse o material sobre o período de configuração."
            target="_blank"
            href="https://suporte.hostgator.com.br/hc/pt-br/articles/30812694986771-O-que-%C3%A9-propaga%C3%A7%C3%A3o"
          />
        </>
      ),
      backToSitesButtonLabel: 'Voltar para Sites',
    },
    domainNotRegisteredSuccess: {
      title: 'Ótima escolha! Você está comprando um novo domínio',
      description: 'Assim que concluído, retorne para o portal para finalizar a configuração do DNS',
      helpLabel: (
        <>
          {'Em caso de dúvidas, '}
          <Link
            text="acesse o material sobre como configurar o DNS."
            target="_blank"
            href="https://suporte.hostgator.com.br/hc/pt-br/articles/30810621770387-Como-configurar-o-dom%C3%ADnio-alterar-DNS"
          />
        </>
      ),
      backToSitesButtonLabel: 'Voltar para Sites',
    },
    externalSuccess: {
      title: 'Pronto! Está tudo certo se você já concluiu a configuração',
      description: 'Aguarde até 2 horas para o site entrar no ar com o novo domínio',
      helpLabel: 'Caso não tenha realizado a configuração no provedor do domínio, retorne ao passo anterior',
      backToLastPageButtonLabel: lastPage => `Ir para ${lastPage}`,
      goBackLabel: 'Voltar',
    },
    externalDomain: {
      titleLabel: 'O domínio indicado foi registrado em outra empresa',
      descriptionLabel: 'Para conectá-lo ao site, aponte o DNS dele para nossa hospedagem.',
      whereFrom: 'Onde seu domínio foi registrado?',

      providers: {
        [PROVIDERS.REGISTROBR]: {
          label: 'Registro.br',
          link: REGISTROBR_HOMEPAGE,
        },
        [PROVIDERS.GODADDY]: {
          label: 'GoDaddy',
          link: GODADDY_HOMEPAGE,
        },
        [PROVIDERS.LOCAWEB]: {
          label: 'Locaweb',
          link: LOCAWEB_HOMEPAGE,
        },
        [PROVIDERS.UOL_HOST]: {
          label: 'UOL Host',
          link: UOLHOST_HOMEPAGE,
        },
        [PROVIDERS.OTHERS]: {
          label: 'Outro',
          link: '',
        },
        [PROVIDERS.COLOMBIA_HOSTING]: {
          label: 'Colombia Hosting',
          link: COLOMBIAHOSTING_HOMEPAGE,
        },
        [PROVIDERS.WEB_EMPRESA]: {
          label: 'Web Empresa',
          link: WEBEMPRESA_HOMEPAGE,
        },
        [PROVIDERS.NEUBOX]: {
          label: 'Neubox',
          link: NEUBOX_HOMEPAGE,
        },
      },
      dnsContentTitle: 'Substitua os registros de DNS do provedor atual pelos da HostGator',
      currentDns: currentProvider => `Dns atual na ${currentProvider}`,
      hostgatorDns: 'DNS da HostGator',
      serverLabel: serverIndex => `Servidor ${serverIndex}: `,
      goBack: 'Voltar',
      continue: 'Continuar',
      configureDomain: 'Configurar domínio',
      copySuccess: 'Texto copiado com sucesso!',
      helpCenterLabel: url => (
        <>
          {'Em caso de dúvidas, '}
          <Link text="Acesse a Central de ajuda" href={url} target="_blank" />
        </>
      ),
      helpCenterUrls: {
        [PROVIDERS.REGISTROBR]: SUPPORT_ARTICLE_CHANGE_DNS_REGISTROBR,
        [PROVIDERS.GODADDY]: SUPPORT_ARTICLE_CHANGE_DNS_GODADDY,
        [PROVIDERS.LOCAWEB]: SUPPORT_ARTICLE_CHANGE_DNS_LOCAWEB,
        [PROVIDERS.UOL_HOST]: SUPPORT_ARTICLE_CHANGE_DNS_UOLHOST,
        [PROVIDERS.OTHERS]: SUPPORT_ARTICLE_CHANGE_DNS_OTHERS,
        [PROVIDERS.COLOMBIA_HOSTING]: SUPPORT_ARTICLE_CHANGE_DNS_COLOMBIAHOSTING,
        [PROVIDERS.WEB_EMPRESA]: SUPPORT_ARTICLE_CHANGE_DNS_WEBEMPRESA,
        [PROVIDERS.NEUBOX]: SUPPORT_ARTICLE_CHANGE_DNS_NEUBOX,
      },
    },
  },
  reinforcementModal: {
    title: 'Você tem certeza que deseja alterar o domínio?',
    description: {
      0: ({ originalDomainName, newDomain }) => (
        <>
          {'Ao continuar, site, e-mail, e outras conexões que possam existir com o domínio '}
          <strong>{`"${originalDomainName}"`}</strong>
          {' vão ser alterados para o novo domínio '}
          <strong>{`"${newDomain}"`}</strong>
          .  É importante estar ciente que você poderá perder suas caixas de e-mail nesse processo, além do seu site não funcionar mais, dependendo da maneira que foi construído, sendo necessário ações manuais da sua parte para correção.
        </>
      ),
      1: (
        <>
          {'Indicamos que antes de prosseguir, realize um backup da sua hospedagem, seguindo as instruções disponíveis no material da '}
          <Link
            href="https://suporte.hostgator.com.br/hc/pt-br/articles/30813484137491-Como-fazer-um-backup-completo"
            text="Central de Ajuda."
          />
        </>
      ),
    },
    continue: 'Estou ciente. Continuar',
    cancel: 'Cancelar',
  },
  breadCrumbs: {
    inputDomain: 'Alterar Domínio',
    externalDomain: 'Domínio externo',
    success: 'Concluir Configuração',
    domainNotRegistered: 'Comprar Domínio',
  },
  blockTemporaryDomainEmailModal: {
    title: 'Configure um domínio pŕoprio',
    description: domain => (
      <>
        <span>
          Para gerenciar uma conta de e-mail, é necessário que esteja utilizando um domínio próprio. Atualmente, você está utilizando o domínio temporário
          {' '}
          <b>
            {domain}
            .
          </b>
          {' '}
          <p>Acesse nosso fluxo de alteração de domínio para realizar essa configuração.</p>
        </span>
        <p>
          Assim que configurar o domínio próprio, retorne para iniciar a criação da sua caixa de e-mail.
        </p>
      </>
    ),
    continueButton: 'Alterar domínio',
    backButton: 'Voltar',
  },
  lastPages: {
    sites: 'Sites',
    produtos: 'Hospedagens e Servidores',
  },
  tempDomainModalBeforeEmail: {
    title: 'Configure um domínio próprio',
    content: optionLabel => (
      <>
        {'Percebemos que um ou mais dos seus sites nessa hospedagem ainda estão usando um domínio temporário. Para acessar a opção '}
        <strong>{`"${optionLabel}"`}</strong>
        , todos os sites já devem estar com um domínio próprio definido. Acesse o fluxo de alteração de domínio para realizar a alteração.
      </>
    ),
    changeDomainLabel: 'Alterar domínio',
    contentAfterList: 'Assim que todos os sites dessa hospedagem estiverem com domínio próprio configurado, retorne para acessar a opção desejada.',
    backLabel: 'Voltar',
  },
  changeDomainBlockModal: {
    title: 'Alteração de Domínio para Criador de Sites',
    description: 'Atualmente não é possível alterar o domínio do site que esteja utilizando o Criador de Sites. Em caso de dúvidas, entre em contato com nosso suporte.',
    buttonLabel: 'Cancelar',
  },
  changeDomainErrorMessage: {
    title: 'Não foi possível alterar o domínio',
    description: openSupport => (
      <>
        Vamos te ajudar pelo nosso
        {' '}
        <button type="button" onClick={openSupport}>chat de atendimento</button>
      </>
    ),
  },
};
